import GoingBack from "../../components/GoingBack/GoingBack";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import IsAdmin from "../../components/Admin/IsAdmin";
import Swal from "sweetalert2";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faXmark, faSort, faSortUp, faSortDown} from "@fortawesome/free-solid-svg-icons";
import DeleteProduct from "../../services/DeleteProduct";
import "./AdminModern.scss";

function AdminAllProducts() {
    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(null);
    const [products, setProducts] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });

    useEffect(() => {
        if (isAdmin === null) {
            return;
        }
        !isAdmin && navigate("/");
    }, [isAdmin]);

    useEffect(() => {
        const fetchAllProducts = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}products`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                const products = await response.json();
                setProducts(products);
            } catch (error) {
                console.log(error);
            }
        };
        fetchAllProducts();
    }, []);

    const handleClickDetails = (idProduit) => {
        navigate("/admin/produit/" + idProduit);
    };

    const handleClickDelete = (idProduct) => {
        DeleteProduct(idProduct, setProducts)
    }

    const EditOrDeleteProduct = p => {
        return (
            <>
                <FontAwesomeIcon icon={faPen} style={{cursor: "pointer", fontSize: "1.2em"}}
                                 onClick={() => handleClickDetails(p.data.id)}/>{' '}
                <FontAwesomeIcon icon={faXmark} style={{cursor: "pointer", margin: "0 0 0 2em", fontSize: "1.5em"}}
                                 onClick={() => handleClickDelete(p.data.id)}/>
            </>
        );
    }

    const sortedProducts = React.useMemo(() => {
        let sortableItems = [...products];
        if (sortConfig.key !== null) {
            sortableItems.sort((a, b) => {
                let aValue = a[sortConfig.key];
                let bValue = b[sortConfig.key];
                if (aValue < bValue) return sortConfig.direction === 'ascending' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'ascending' ? 1 : -1;
                return 0;
            });
        }
        return sortableItems;
    }, [products, sortConfig]);

    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <FontAwesomeIcon icon={faSort} style={{ marginLeft: "0.5rem", opacity: 0.3 }} />;
        }
        if (sortConfig.direction === 'ascending') {
            return <FontAwesomeIcon icon={faSortUp} style={{ marginLeft: "0.5rem" }} />;
        }
        return <FontAwesomeIcon icon={faSortDown} style={{ marginLeft: "0.5rem" }} />;
    };
    return (
        <div className="admin-modern-container">
            <IsAdmin setAdmin={setIsAdmin}/>
            <GoingBack/>
            {!isAdmin ? null : (
                <>
                    <div className="admin-header">
                        <h2>Catalogue des produits</h2>
                        <p>Gérez l'ensemble des produits de la boutique</p>
                    </div>

                    <div className="admin-card">
                        <div className="admin-data-list">
                            <div className="admin-data-header">
                                <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('name')}>
                                    Nom {getSortIcon('name')}
                                </div>
                                <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('category')}>
                                    Catégorie {getSortIcon('category')}
                                </div>
                                <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('price')}>
                                    Prix {getSortIcon('price')}
                                </div>
                                <div style={{ cursor: "pointer", userSelect: "none" }} onClick={() => requestSort('onSale')}>
                                    En Ligne {getSortIcon('onSale')}
                                </div>
                                <div style={{ flex: "0 0 100px", textAlign: "right" }}>Actions</div>
                            </div>
                            
                            {sortedProducts.map((product, index) => (
                                <div key={index} className="admin-data-card">
                                    <div className="admin-data-row">
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Nom</span>
                                            <span className="admin-data-value" style={{ fontWeight: "bold" }}>{product.name}</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Catégorie</span>
                                            <span className="admin-data-value">{product.category} {product.secondary_category ? `> ${product.secondary_category}` : ''}</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">Prix</span>
                                            <span className="admin-data-value">{product.price} €</span>
                                        </div>
                                        <div className="admin-data-item">
                                            <span className="admin-data-label">En Ligne</span>
                                            {product.onSale ? 
                                                <span className="admin-badge admin-badge-success">Oui</span> : 
                                                <span className="admin-badge admin-badge-danger">Non</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="admin-data-actions">
                                        <button className="admin-btn admin-btn-outline" style={{ padding: "0.5rem", marginRight: "0.5rem", color: "var(--admin-primary)", borderColor: "var(--admin-primary)" }} onClick={() => handleClickDetails(product.id)}>
                                            <FontAwesomeIcon icon={faPen} />
                                        </button>
                                        <button className="admin-btn admin-btn-outline" style={{ padding: "0.5rem", color: "var(--admin-danger)", borderColor: "var(--admin-danger-bg)" }} onClick={() => handleClickDelete(product.id)}>
                                            <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                            {products.length === 0 && (
                                <div style={{ textAlign: "center", padding: "2rem", color: "var(--admin-text-muted)" }}>
                                    Aucun produit trouvé.
                                </div>
                            )}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default AdminAllProducts;
